<template>
  <v-row>
    <!-- sessionPrice -->
    <v-col cols="12" md="3" class="pb-0 px-1">
      <v-text-field
        label="Prix de la séance"
        color="secondary"
        type="number"
        suffix="dinars"
        v-model="sessionPrice"
      />
    </v-col>
    <!-- sessionLength -->
    <v-col cols="12" md="3" class="pb-0 px-1">
      <v-text-field
        label="Longuer de la séance"
        color="secondary"
        prepend-inner-icon="mdi-clock"
        type="number"
        suffix="Min"
        v-model="sessionLength"
      />
    </v-col>
    <!-- CNAM -->
    <v-col cols="12" md="3" class="pb-0 pt-1 px-1">
      <v-switch color="success" :ripple="false" label="Conventioné avec CNAM?" v-model="cnam"></v-switch>
    </v-col>
    <!-- online -->
    <v-col cols="12" md="3" class="pb-0 pt-1 px-1">
      <v-switch color="success" :ripple="false" v-model="online" label="tu travail en ligne?"></v-switch>
    </v-col>
    <!-- openningHours -->
    <AddOpenningHours :openningHours.sync="openningHours" />
  </v-row>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, minValue } from "vuelidate/lib/validators";

import AddOpenningHours from "@/components/profile/AddOpenningHours";

export default {
  mixins: [validationMixin],
  validations: {
    sessionPriceLocal: { required, minValue: minValue(10) },
    sessionLengthLocal: { required, minValue: minValue(30) },
    descriptionLocal: { minLength: minLength(10) }
  },
  components: { AddOpenningHours },
  props: [
    "sessionPrice",
    "sessionLength",
    "online",
    "cnam",
    "openningHours",
    "type"
  ],
  methods: {
    isValide() {
      this.$v.$touch();
      return !this.$v.$invalid;
    }
  },
  computed: {
    hours: () => {
      let hours = [];
      for (let i = 420; i < 1350; i += 30) {
        hours.push(
          moment()
            .startOf("day")
            .add(i, "minutes")
            .format("HH:mm")
        );
      }
      return hours;
    },
    sessionPriceLocal: {
      get() {
        return this.sessionPrice;
      },
      set(value) {
        this.$emit("update:sessionPrice", value);
      }
    },
    sessionLengthLocal: {
      get() {
        return this.sessionLength;
      },
      set(value) {
        this.$emit("update:sessionLength", value);
      }
    },
    cnamLocal: {
      get() {
        return this.cnam;
      },
      set(value) {
        this.$emit("update:cnam", value);
      }
    },
    onlineLocal: {
      get() {
        return this.online;
      },
      set(value) {
        this.$emit("update:online", value);
      }
    },
    openningHoursLocal: {
      get() {
        return this.openningHours;
      },
      set(value) {
        this.$emit("update:openningHours", value);
      }
    },
    atHomeLocal: {
      get() {
        return this.atHome;
      },
      set(value) {
        this.$emit("update:atHome", value);
      }
    },
    // VALIDATION ERRORS
    sessionPriceErrors() {
      const errors = [];
      if (!this.$v.sessionPriceLocal.$dirty) return errors;
      !this.$v.sessionPriceLocal.minValue &&
        errors.push("Le prix minimum est 10");
      !this.$v.sessionPriceLocal.required &&
        errors.push("Ce champ est obligatoire.");
      return errors;
    },
    sessionLengthErrors() {
      const errors = [];
      if (!this.$v.sessionLengthLocal.$dirty) return errors;
      !this.$v.sessionLengthLocal.minValue &&
        errors.push("La durée minimum est 30");
      !this.$v.sessionLengthLocal.required &&
        errors.push("Ce champ est obligatoire.");
      return errors;
    }
  }
};
</script>